<template>
  <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
    <article v-for="post in props.posts.slice(showPostsFromIndex)" :key="post.id" class="group cursor-pointer rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
      <div class="block" @click="viewPost(getBlogPostIdentifier(post))">
        <div class="relative overflow-hidden h-48 md:h-52 rounded-lg mb-4">
          <img
            v-if="post._embedded?.['wp:featuredmedia']?.[0]?.source_url"
            :src="post._embedded['wp:featuredmedia'][0].source_url"
            :alt="post.title.rendered"
            class="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
          />
        </div>
        <div>
          <p :class="['text-sm font-semibold mb-2', useBusinessLatestBlogStyle ? 'text-grey-dark-300' : 'text-primary']">
            {{ getExcerptText(post._embedded?.['wp:term']?.[0]?.[0]?.name) }}
          </p>
          <div class="flex items-start gap-2 mb-2">
            <h3
              :class="['text-lg font-bold group-hover:text-primary transition-colors line-clamp-2 flex-1', { 'md:text-2xl ': useBusinessLatestBlogStyle }]"
              v-html="post.title.rendered"
            ></h3>
            <ArrowUpRight class="w-5 h-5 flex-shrink-0 mt-1" />
          </div>
          <p :class="['text-md mb-3 line-clamp-3', { 'text-grey-dark-300': useBusinessLatestBlogStyle }]">
            {{ getExcerptText(post.excerpt?.rendered) }}
          </p>
        </div>
      </div>
    </article>
  </div>
</template>

<script setup lang="ts">
import { type BlogPost } from '@/services/blogService';
import { useThemeStore } from '@/stores/theme';
import { decodeHtmlEntities as getBlogExcerptText, getBlogPostIdentifier } from '@/utils/blog';
import { ArrowUpRight } from 'lucide-vue-next';
import { useRouter } from 'vue-router';

const router = useRouter();
interface Props {
  posts: BlogPost[];
  showPostsFromIndex?: number;
  useBusinessLatestBlogStyle?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  showPostsFromIndex: 1
});

const themeStore = useThemeStore();

const viewPost = (postId: string) => {
  router.push({
    name: `${themeStore.mode || 'shopper'}-blog-post`,
    params: { id: postId },
    query: router.currentRoute.value.query, // Preserve current query parameters
  });
};

const getExcerptText = getBlogExcerptText;
</script>
